import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { PostHogProvider } from 'posthog-js/react';
import { IStaticMethods } from 'preline/preline';
import { HelmetProvider } from 'react-helmet-async';

declare global {
  interface Window {
    HSStaticMethods: IStaticMethods;
  }
}
const options = {
  api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
}

const apiKey = process.env.REACT_APP_PUBLIC_POSTHOG_KEY || '';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <PostHogProvider 
      apiKey={apiKey}
      options={options}
    >
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </PostHogProvider>
  </React.StrictMode>
);

// Initialize Preline
import('preline/preline').then(() => {
  window.HSStaticMethods.autoInit();
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
